import type { NodeType } from './types'

export const wellsLimit = 100

export const dummyCount = 2

export const wellsRoot = 'wells'
export const markersRoot = 'markers'
export const cubesRoot = 'cubes'

export const rootNode: NodeType = 'root'
export const fieldNode: NodeType = 'field'
export const wellNode: NodeType = 'well'
export const markerNode: NodeType = 'marker'
export const cubeNode: NodeType = 'cube'
export const dummyNode: NodeType = 'dummy'
